import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { networkProviderRequest } from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import ReactTooltip from "react-tooltip";
import { ProgressSpinner } from "primereact/progressspinner";
import { format } from "date-fns";
import { Toast } from "primereact/toast";

export const RemittanceNetworks = () => {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [datetime24h, setDateTime24h] = useState(null);
  const [networkAlias, setNetworkAlias] = useState("");
  const [name, setName] = useState("");
  const [countryName, setCountryName] = useState(""); // Added state for country filter
  const [dropdownSearchFilter, setDropdownSearchFilter] = useState("name"); // Default to "name"
  const [searchValue, setSearchValue] = useState("");
  const [providers, setProviders] = useState([]);
  const toast = useRef(null);

  // Define the options for the search filter dropdown
  const searchFilterOptions = [
    { label: "Name", value: "name" },
    { label: "Network Alias", value: "networkAlias" },
  ];
  const [showViewModal, setShowViewModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [date, setDate] = useState({
    rangeValue: [new Date(), new Date()],
  });
  const [selectedData, setSelectedData] = useState({
    name: "",
    network_alias: "",
    type: "",
    provider: "",
    country_name: "",
  });
  const [updateData, setUpdateData] = useState({
    id: "",
    status: "",
    network_alias: "",
    type: "",
    provider: "",
  });

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "#999",
    fontWeight: "500",
  };
  const detailsStyleNew = {
    fontSize: "14px",
    color: "rgb(92, 74, 181)",
    float: "left",
  };

  const type = [
    { key: "MNO", value: "Mobile Network Operator" },
    { key: "BANK", value: "Bank" },
  ];
  const status = [
    { key: 1, value: "True" },
    { key: 0, value: "False" },
  ];
  const [countries, setCountries] = useState([]);

  const [data, setData] = useState([
    { name: "Name", value: "" },
    { name: "Status", value: "" },
    { name: "Network Alias", value: "" },
    { name: "Country Name", value: "" },
    { name: "Type", value: "" },
    { name: "Provider", value: "" },
    { name: "Requested by", value: "" },
    { name: "Approved by", value: "" },
    { name: "Created at", value: "" },
  ]);

  const handleViewModalDisplay = (rowData) => {
    setData([
      { name: "Name", value: rowData.name },
      { name: "Status", value: rowData.status },
      { name: "Network Alias", value: rowData.networkAlias },
      { name: "Country Name", value: rowData.countryName },
      { name: "Type", value: rowData.type },
      { name: "Provider", value: rowData.providerId },
      { name: "Requested by", value: rowData.requestedByName },
      { name: "Approved by", value: rowData.approvedByName },
      { name: "Created at", value: rowData.createdOn },
    ]);
    setShowViewModal(!showViewModal);
  };

  const getValue = (array, key) => {
    const Obj = array.find((i) => i.key === key);
    console.log("this is the objjjjj:", Obj);
    return Obj ? Obj : "N/A";
  };

  const handleUpdateModalDisplay = (rowData) => {
    setUpdateData({
      id: rowData.id,
      status: getValue(status, rowData.status).key,
      network_alias: rowData.networkAlias,
      type: rowData.type,
      provider: rowData.providerId,
    });
    // console
    setShowUpdateModal(!showUpdateModal);
  };
  const handleAddModalDisplay = () => {
    setShowAddModal(!showAddModal);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-pencil"
        className="p-button-info p-mr-2"
        onClick={() => handleUpdateModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Take Action"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
    </>
  );

  const userDetails = useSelector((state) => state.login.userDetails);
  console.log("data", userDetails);

  const fetchData = async () => {
    setLoading(true); // Start loading

    setCountries(userDetails.allCountries);

    const requestData = {
      country_name: countryName || "", // Update with state
      created_at: datetime24h ? datetime24h.toISOString() : "", // Convert date to ISO format
      network_alias: networkAlias || "", // Update with state
      name: name || "", // Update with state
      size: "9999999",
    };

    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredRequestData).toString();
    try {
      const response = await networkProviderRequest(
        "get",
        `api/v1/networkandprovider/network/filter?${queryString}`
      );
      if (response.code === "00") {
        const fetchedData = response.data;
        setCustomers(fetchedData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const addNetwork = async () => {
    console.log("selected", selectedData);
    setIsClicked(true);

    const requestData = {
      name: selectedData.name,
      status: 0,
      networkAlias: selectedData.network_alias,
      type: selectedData.type,
      providerId: selectedData.provider,
      countryName: selectedData.country_name,
      requestedBy: userDetails._id,
      requestedByName: userDetails.userName,
      approvedBy: userDetails._id,
      approvedByName: userDetails.userName,
    };
    try {
      const response = await networkProviderRequest(
        "post",
        "/api/v1/networkandprovider/network",
        requestData
      );
      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "failure",
          summary: "Failed",
          detail: response.message,
          life: 3000,
        });
        console.error("Failed to Add network:", response.message);
      }
    } catch (error) {
      toast.current.show({
        severity: "failure",
        summary: "Failed",
        life: 3000,
      });
      console.error("Error Adding network", error);
    }
    setShowAddModal(false);
  };

  const updateNetwork = async () => {
    console.log("selected", updateData);

    const requestData = {
      id: updateData.id,
      status: getValue(status, updateData.status).key,
      networkAlias: updateData.network_alias,
      type: updateData.type,
      providerId: updateData.provider,
      requestedBy: userDetails._id,
      requestedByName: userDetails.userName,
      approvedBy: userDetails._id,
      approvedByName: userDetails.userName,
    };
    try {
      const response = await networkProviderRequest(
        "put",
        `/api/v1/networkandprovider/network`,
        requestData
      );
      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "failure",
          summary: "Failed",
          detail: response.message,
          life: 3000,
        });
        console.error("Failed to update:", response.message);
      }
    } catch (error) {
      toast.current.show({
        severity: "failure",
        summary: "Failed",
        life: 3000,
      });
      console.error("Error updating:", error);
    }
    setShowUpdateModal(false);
  };
  const fetchProviders = async () => {
    try {
      const response = await networkProviderRequest(
        "get",
        "/api/v1/networkandprovider/provider?size=9999999"
      );
      if (response.code === "00") {
        const fetchedData = response.data;
        console.log("Providers", fetchedData);
        setProviders(fetchedData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchProviders();
  }, [datetime24h, countryName, networkAlias, name]); // Re-fetch data when filters change

  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const getSearchedData = () => {
    if (dropdownSearchFilter === "name") {
      setName(searchValue); // Set name if the filter is for name
    } else if (dropdownSearchFilter === "networkAlias") {
      setNetworkAlias(searchValue); // Set networkAlias if the filter is for network alias
    }
    fetchData(); // Re-fetch the data with the updated filters
  };

  const formatCreatedOn = (rowData) => {
    return rowData.createdOn
      ? format(new Date(rowData.createdOn), "yyyy-MM-dd HH:mm:ss")
      : "";
  };

  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />
      <div className="p-grid p-fluid">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Remittance Network</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div
          className="p-grid p-align-center p-fluid"
          style={{ paddingTop: "30px" }}
        >
          {/* Date Range Picker */}
          <div className="p-field p-col-12 p-md-3">
            <span className="p-float-label">
              <Calendar
                id="calendar-24h"
                value={datetime24h}
                onChange={(e) => {
                  setDateTime24h(e.value);
                  fetchData(); // Fetch data when date is selected
                }}
                showTime
                hourFormat="24"
                placeholder="Date Created At"
              />
            </span>
          </div>

          {/* Status Dropdown */}
          <div className="p-field p-col-12 p-md-3">
            <span className="p-float-label">
              <Dropdown
                style={{ width: "100%" }}
                options={searchFilterOptions} // Use the search filter options defined
                value={dropdownSearchFilter}
                onChange={(event) => setDropdownSearchFilter(event.value)}
                autoWidth={false}
              />
              <label style={floatLabel}>Select Filter</label>
            </span>
          </div>

          {/* Search Input */}
          <div className="p-field p-col-12 p-md-3">
            <div className="p-inputgroup">
              <InputText
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder={
                  dropdownSearchFilter === "name"
                    ? "Enter Name"
                    : "Enter Network Alias"
                } // Dynamic placeholder
              />
              <Button
                onClick={getSearchedData}
                icon="pi pi-search"
                className="p-button-info"
              />
            </div>
          </div>

          <div
            className="p-field p-col-12 p-md-3"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              label=""
              icon="pi pi-plus"
              className="p-button-info p-mr-2"
              onClick={() => handleAddModalDisplay()}
              style={{ fontSize: "15px", padding: "7px" }}
              data-tip="Add Network"
              data-for="toolTip1"
              data-place="top"
            />
          </div>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={customers}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="name"
              header="Network Operator"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="networkAlias"
              header="Network Alias"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="type"
              header="Type"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="countryName"
              header="Country Name"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="requestedByName"
              header="Requested By"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="approvedByName"
              header="Approved By"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="createdOn"
              header="Date Created"
              style={{ width: "25%" }}
              body={formatCreatedOn} // Use the custom formatting function
            ></Column>
            <Column
              header="Actions"
              style={{ width: "25%" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <CustomDialog
        visible={showViewModal}
        header="Network Details"
        onClose={() => setShowViewModal(false)}
      >
        <ViewLayout data={data} />
      </CustomDialog>
      <CustomDialog
        visible={showAddModal}
        header="Add Network"
        onClose={() => setShowAddModal(false)}
        label="Add"
        handleSubmit={addNetwork}
      >
        <FormLayout
          selectedData={selectedData}
          labelStyle={labelStyle}
          handleInputChange={handleInputChange}
          type={type}
          modalType="ADD"
          countries={countries}
          provider={providers}
        />
      </CustomDialog>
      <CustomDialog
        visible={showUpdateModal}
        header="Edit Network"
        onClose={() => setShowUpdateModal(false)}
        label="Submit"
        handleSubmit={updateNetwork}
      >
        <FormLayout
          selectedData={updateData}
          labelStyle={labelStyle}
          handleInputChange={handleUpdateInputChange}
          type={type}
          modalType="UPDATE"
          status={status}
          countries={countries}
          provider={providers}
        />
      </CustomDialog>
    </section>
  );
};

const ViewLayout = ({ data }) => {
  if (!Array.isArray(data)) {
    return <div>No data available</div>;
  }

  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <div>
            {data.map((item, index) => (
              <div className="p-grid" key={index}>
                <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                  <label>{item.name}</label>
                </div>
                <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                  <label>{item.value}</label>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const FormLayout = ({
  selectedData,
  handleInputChange,
  type = [],
  status = [],
  countries = [],
  provider = [],
  labelStyle,
  modalType,
}) => {
  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ marginTop: "20px" }}
            >
              {modalType === "ADD" ? (
                <span className="p-float-label">
                  <InputText
                    name="name"
                    value={selectedData.name}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="dropdown1" style={labelStyle}>
                    Name
                  </label>
                </span>
              ) : (
                <span className="p-float-label">
                  <Dropdown
                    name="status"
                    options={status.map((t) => ({
                      label: t.value,
                      value: t.key,
                    }))}
                    value={selectedData.status}
                    onChange={handleInputChange}
                    autoWidth={false}
                  />
                  <label htmlFor="dropdown1" style={labelStyle}>
                    Status
                  </label>
                </span>
              )}
            </div>
            {modalType === "ADD" ? (
              <div
                className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
                style={{ marginTop: "20px" }}
              >
                <span className="p-float-label">
                  <Dropdown
                    name="country_name"
                    options={countries.map((t) => ({
                      label: t.label,
                      value: t.value,
                    }))}
                    value={selectedData.country_name}
                    onChange={handleInputChange}
                    autoWidth={false}
                  />
                  <label htmlFor="dropdown1" style={labelStyle}>
                    Country
                  </label>
                </span>
              </div>
            ) : (
              <span></span>
            )}

            <div
              className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ marginTop: "20px" }}
            >
              <span className="p-float-label">
                <Dropdown
                  name="provider"
                  options={provider.map((t) => ({
                    label: t.name ? t.name : t.id,
                    value: t.id,
                  }))}
                  value={selectedData.provider}
                  onChange={handleInputChange}
                  autoWidth={false}
                />
                <label htmlFor="dropdown1" style={labelStyle}>
                  Provider
                </label>
              </span>
            </div>
            <div
              className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ marginTop: "20px" }}
            >
              <span className="p-float-label">
                <Dropdown
                  name="type"
                  options={type.map((t) => ({ label: t.value, value: t.key }))}
                  value={selectedData.type}
                  onChange={handleInputChange}
                  autoWidth={false}
                />
                <label htmlFor="dropdown1" style={labelStyle}>
                  Type
                </label>
              </span>
            </div>
            <div
              className="p-col-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ marginTop: "20px" }}
            >
              <span className="p-float-label">
                <InputText
                  name="network_alias"
                  value={selectedData.network_alias}
                  onChange={handleInputChange}
                />
                <label htmlFor="dropdown1" style={labelStyle}>
                  Network Alias
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
